"use client";
import {
  __async
} from "../../chunk-MMUBH76A.js";
import { useEffect, useState } from "react";
import { useInternalClient } from "../../provider/hooks/utils/useInternalClient.js";
import { useActiveWallet } from "./useActiveWallet.js";
import { WalletType } from "@getpara/web-sdk";
import { useExternalWallets } from "../providers/ExternalWalletContext.js";
import { useStore } from "../../provider/stores/useStore.js";
function useWalletBalance() {
  const client = useInternalClient();
  const wallet = useActiveWallet();
  const [balance, setBalance] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const { balance: externalWalletBalance } = useExternalWallets();
  const rpcUrl = useStore((state) => state.rpcUrl);
  useEffect(() => {
    const loadBalance = () => __async(this, null, function* () {
      const skipGetBalance = !wallet || [WalletType.COSMOS, WalletType.SOLANA].includes(wallet.type);
      if (skipGetBalance) {
        setBalance(void 0);
        return;
      }
      setIsLoading(true);
      if (wallet.isExternal) {
        setBalance(externalWalletBalance);
      } else {
        try {
          if (rpcUrl) {
            const balance2 = yield client.getWalletBalance({
              walletId: wallet.id,
              rpcUrl
            });
            setBalance(balance2);
          }
        } catch (err) {
          console.error("Error fetching wallet balance: ", err);
        }
      }
      setIsLoading(false);
    });
    loadBalance();
  }, [wallet == null ? void 0 : wallet.id, wallet == null ? void 0 : wallet.type, wallet == null ? void 0 : wallet.isExternal, externalWalletBalance]);
  return { balance, isLoading };
}
export {
  useWalletBalance
};
